import { defineStore } from 'pinia'

/**
 * Converted from store/snackbar.js.
 *
 * NO `snack` GETTER. Vuex had one, a pure pass-through of the same-named state
 * field, and Vuex kept getters and state in separate namespaces so the two
 * could share a name. Pinia merges them onto one object, where a getter SHADOWS
 * the state key and makes it readonly — `this.snack = x` inside an action then
 * fails silently. The state field alone serves every caller: the facade resolves
 * `snackbar/snack` against the store, and a state key is on the store.
 */
export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    snack: undefined as unknown,
  }),
  actions: {
    set(snack: unknown): void {
      this.snack = snack
      // eslint-disable-next-line no-console
      console.debug('Store: SET SNACK', snack)
    },
    clear(): void {
      this.snack = undefined
    },
  },
})
